import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import { environment } from '../../environments/environment';

const outFields = [
  'OBJECTID',
  'antallkunder',
  'kommune',
  'poststed',
  'strombruddoppdaget',
  'utkoblingstart',
  'utkoblingslutt',
  'avbruddstype',
  'nettstasjon',
] as const;

const config = {
  url: environment.ARCGIS_FEATURE_SERVER,
  outFields: [...outFields],
};

/**
 * Feature Layer representing outage points
 */
export const outagesPointLayer = new FeatureLayer({
  ...config,
  layerId: 0,
  maxScale: 40001,
  opacity: 0.7,
  refreshInterval: 1,
});

/**
 * Feature Layer representing outage areas as polygons
 */
export const outagesPolygonLayer = new FeatureLayer({
  ...config,
  layerId: 1,
  minScale: 40000,
  opacity: 0.5,
  refreshInterval: 1,
});
